// removed by extract-text-webpack-plugin
module.exports = {"SendFromEdit":"SendFromEdit---Fimb_"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/shared/SendFromEdit/style.styl
// module id = UQNy
// module chunks = 89